// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';
const swiperBlock = document.querySelectorAll(".slider-container-images");

if(swiperBlock.length > 0) {
  const slidesDelay = Number(document.querySelector(".quotes-slider-block__right").dataset.autospeed);

  const swiperImages = new Swiper(".slider-container-images", {
    spaceBetween: 0,
    keyboardControl: false,
    mousewheelControl: false,
  });

  new Swiper(".slider-block__quote", {
    loop: true,
    autoplay: {
      delay: slidesDelay,
    },
    spaceBetween: 0,
    slidesPerView: 1,
    watchSlidesProgress: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    thumbs: {
      swiper: swiperImages,
    },
  });
}


